(function () {
const $d36c5ca33ffddb30$var$accordion = ()=>{
    let acc = document.getElementsByClassName("accordion");
    //if no accordion
    if (!acc.length) return;
    for(let i = 0; i < acc.length; i++){
        let title = acc[i].querySelector(".accordion__title");
        title.addEventListener("click", function() {
            this.parentNode.classList.toggle("active");
            let panel = this.nextElementSibling;
            if (panel.style.maxHeight) panel.style.maxHeight = null;
            else panel.style.maxHeight = panel.scrollHeight + "px";
        });
    }
};
var $d36c5ca33ffddb30$export$2e2bcd8739ae039 = $d36c5ca33ffddb30$var$accordion;


const $e0aa5e0a25e30a1d$var$Filters = ()=>{
    //----------------------------------------------------------------
    // Remove filters checked
    //----------------------------------------------------------------
    function uncheck(checkbox) {
        const els = document.querySelectorAll(checkbox);
        if (els) els.forEach((el)=>el.checked = false);
    }
    // Fonction pour mettre à jour la liste des cases activées
    function updateActiveCheckboxes(checkbox, activeList, btnRemoveFilter) {
        const checkboxItemID = checkbox.getAttribute("ID"); // get the ID of the checkbox
        // check if the checkbox is checked
        if (checkbox.checked) {
            const label = document.querySelector("label[for=" + checkboxItemID + "]"); // get label checkbox
            const listItem = document.createElement("li");
            listItem.textContent = label.innerHTML;
            listItem.setAttribute("id", checkboxItemID);
            listItem.classList.add("filter-activated");
            activeList.appendChild(listItem); //Ajouter une entrée dans la liste des cases activées
            // remove element if clicked on
            listItem.addEventListener("click", (el)=>{
                const elID = el.target.getAttribute("ID");
                activeList.removeChild(listItem);
                uncheck("#" + checkboxItemID);
                displayListAndButton(activeList, btnRemoveFilter);
            });
        } else {
            const checkboxAlreadyAppend = activeList.querySelector("#" + checkboxItemID);
            if (checkboxAlreadyAppend) checkboxAlreadyAppend.remove();
        }
        displayListAndButton(activeList, btnRemoveFilter);
    }
    function displayListAndButton(activeList, btnRemoveFilter) {
        if (activeList.childElementCount > 0 || !activeList.classList.contains("is-active")) {
            activeList.classList.add("is-active");
            btnRemoveFilter.classList.add("is-active");
        } else {
            activeList.classList.remove("is-active");
            btnRemoveFilter.classList.remove("is-active");
        }
    }
    const filtersBloc = document.querySelectorAll(".filters");
    if (!filtersBloc.length > 0) return;
    filtersBloc.forEach((filterBloc)=>{
        const btnRemoveFilter = filterBloc.querySelector(".btnRemoveFilterJs");
        const activeList = filterBloc.querySelector(".activeCheckboxes"); //where to display actived filters
        // action on btn remove filter
        if (btnRemoveFilter) btnRemoveFilter.addEventListener("click", ()=>{
            const newURL = location.href.split("?")[0];
            window.location = newURL;
        });
        // foreach filter
        filterBloc.querySelectorAll('input[type="checkbox"]').forEach((checkbox)=>{
            // on load
            updateActiveCheckboxes(checkbox, activeList, btnRemoveFilter);
            // Ajouter un écouteur d'événements à toutes les cases à cocher
            checkbox.addEventListener("change", (event)=>{
                updateActiveCheckboxes(event.currentTarget, activeList, btnRemoveFilter);
            });
        });
    });
};
var $e0aa5e0a25e30a1d$export$2e2bcd8739ae039 = $e0aa5e0a25e30a1d$var$Filters;



addEventListener("DOMContentLoaded", (event)=>{
    (0, $d36c5ca33ffddb30$export$2e2bcd8739ae039)();
    (0, $e0aa5e0a25e30a1d$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=archive-travel.js.map
